module.exports = __webpack_public_path__ + "static/media/availability-slide-9.ce89c05d.jpg";